import { Colors, Fonts } from '../../../../shared/theme';
import { textStyles } from '../../../../shared/theme/fonts-ppv';

export default {
  formWrapper: {
    backgroundColor: Colors.white,
    padding: 40,
    minWidth: 'fit-content',
  } as React.CSSProperties,
  headerRemark: {
    marginBottom : '20px'
  } as React.CSSProperties,
  textRegular14DarkGray: {
    ...textStyles.body2,
    fontSize: Fonts.size.text14,
    color: Colors.font.primary.darkGray
  } as React.CSSProperties,
};
